import React from 'react'
import { observer } from 'mobx-react'
import { Image } from '@winnin/winnin_ui.components.image'

import { BaseSkeleton } from 'components/BaseSkeleton'
import { T } from 'lib/tolgee'
import { VideoModalStore } from 'stores'
import { humanizeLargeNumber } from 'utils'

import BlockedLinkWrapper from '../BlockedLinkWrapper'

const TOLGEE_PREFIX = 'Territory-Subjects'

function SubjectsList({ subjects, onClick, isUserViewer, onTrackClick }) {
  const firstPosition = subjects?.[0]
  const filteredSubjects = subjects?.slice(1)

  function handleVideoClick(currentVideo) {
    const formattedCurrentVideo = {
      postId: currentVideo?.postId,
      provider: currentVideo?.provider,
    }

    VideoModalStore.setVideo({ currentVideo: formattedCurrentVideo })
  }

  return (
    <div className="TerritorySubjects-list">
      <div className="TerritorySubjects-withPosts">
        <div className="TerritorySubjects-item">
          <BlockedLinkWrapper
            to={() => onClick(firstPosition)}
            isClickBlocked={isUserViewer}
            className="TerritorySubjects-name"
            onClick={() => onTrackClick(firstPosition)}
          >
            {firstPosition?.name}
          </BlockedLinkWrapper>
          <span className="TerritorySubjects-description">
            {firstPosition?.avgEngagement < 0 ? (
              <BaseSkeleton height={16} borderRadius={20} width={150} />
            ) : (
              <T
                keyName={`${TOLGEE_PREFIX}-territoryDescription`}
                parameters={{ avgEngagement: humanizeLargeNumber(firstPosition?.avgEngagement, 2) }}
              >
                {'{avgEngagement} engagement/video'}
              </T>
            )}
          </span>
        </div>

        <div className="TerritorySubjects-posts">
          {firstPosition?.posts?.map(post => {
            return (
              <button key={post?.postId} onClick={() => handleVideoClick(post)}>
                <Image alt="video thumbnail" src={post?.thumbnail} height={65} width={115} />
              </button>
            )
          })}
        </div>
      </div>
      <div className="TerritorySubjects-wrapper">
        {filteredSubjects?.map(territory => {
          return (
            <div key={territory?.territoryId} className="TerritorySubjects-item">
              <BlockedLinkWrapper
                to={() => onClick(territory)}
                isClickBlocked={isUserViewer}
                className="TerritorySubjects-name"
                onClick={() => onTrackClick(territory)}
              >
                {territory?.name}
              </BlockedLinkWrapper>

              <span className="TerritorySubjects-description">
                {territory?.avgEngagement < 0 ? (
                  <BaseSkeleton height={16} borderRadius={20} width={150} />
                ) : (
                  <T
                    keyName={`${TOLGEE_PREFIX}-territoryDescription`}
                    parameters={{ avgEngagement: humanizeLargeNumber(territory?.avgEngagement, 2) }}
                  >
                    {'{avgEngagement} engagement/video'}
                  </T>
                )}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default observer(SubjectsList)
